module.exports = __webpack_public_path__ + "static/media/5.f9f0c539.svg";